import {indent} from '/constant/layout.constant';
import {createWebEnhancedStyles} from '/util/webStyles.util';

export const styles = createWebEnhancedStyles({
  sceneContainerStyle: {
    paddingTop: 0,
  },
  tabBarStyle: {
    marginTop: 0,
    paddingTop: 0,
  },
  tabBarItemStyle: {
    width: 'auto',
    minWidth: 'auto',
    paddingVertical: 0,
    paddingHorizontal: indent * 0.25,
    marginLeft: indent * 0.75,
    marginRight: indent * 0.75,
  },
  tabBarIndicatorContainerStyle: {
    marginLeft: indent * 0.75,
  },
});
